module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container Paymentdetails2sAdd"
  }, [_c('form', {
    staticClass: "h-adr"
  }, [_c('p', {
    staticClass: "m-label"
  }, [_vm._v("新規追加")]), _vm._v(" "), _c('paymentdetails2-form', {
    attrs: {
      "paymentdetails2": _vm.paymentdetails2,
      "watch": _vm.watch
    }
  }), _vm._v(" "), _c('btn', {
    staticClass: "u-btn u-btn--add",
    nativeOn: {
      "click": function($event) {
        return _vm.postPaymentdetails2($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-contract-plus"
  }), _vm._v("paymentdetails2を新規追加")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5578f616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Paymentdetails2s/Paymentdetails2sAdd.vue
// module id = 1379
// module chunks = 0